// Shared extension/label → MIME type mapping, used wherever a blob is built
// from raw file bytes (Salesforce ContentVersion downloads have no MIME
// type of their own — only a short type label like "PDF" and/or a
// fileName with an extension) and needs a real MIME type so the browser
// renders it (inline PDF/image/video) instead of treating it as opaque
// binary/text.
export const MIME_TYPES_BY_EXTENSION: Record<string, string> = {
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    mp4: 'video/mp4',
    mov: 'video/quicktime',
    txt: 'text/plain',
};

export const getMimeTypeForExtension = (extension: string): string =>
    MIME_TYPES_BY_EXTENSION[extension.toLowerCase()] || 'application/octet-stream';

export const getMimeTypeForFileName = (fileName?: string): string => {
    const extension = fileName?.split('.').pop() || '';
    return getMimeTypeForExtension(extension);
};

export const getExtensionFromMimeType = (mimeType: string): string => {
    const entry = Object.entries(MIME_TYPES_BY_EXTENSION).find(([, mime]) => mime === mimeType);
    return entry?.[0] || '';
};
